// Tab enum for System Configuration
export enum SystemConfigurationTab {
  POS_LOCATION_CONFIGURATIONS = 'POS_LOCATION_CONFIGURATIONS',
  EXTERNAL_CONFIGURATIONS = 'EXTERNAL_CONFIGURATIONS',
  STATIC_QR = 'STATIC_QR',
  HOSTED_PAYMENT = 'HOSTED_PAYMENT',
}

// Tab labels mapping
export const SystemConfigurationTabLabels: Record<
  SystemConfigurationTab,
  string
> = {
  [SystemConfigurationTab.POS_LOCATION_CONFIGURATIONS]:
    'POS Location configurations',
  [SystemConfigurationTab.EXTERNAL_CONFIGURATIONS]: 'External configurations',
  [SystemConfigurationTab.STATIC_QR]: 'Static QR',
  [SystemConfigurationTab.HOSTED_PAYMENT]: 'Hosted Payment',
};
